import React, { useState, useEffect, useContext } from 'react';
import { Pagination, Button, Tooltip } from 'antd';
import './list.scss';
import { useHistory } from 'react-router-dom';
import http from '@/server';
import { Context } from '@/models/home';

function NewList() {
  function itemRender(current, type, originalElement) {
    if (type === 'prev') {
      return <Button>上一页</Button>;
    }
    if (type === 'next') {
      return <Button>下一页</Button>;
    }
    return originalElement;
  }

  const HomeContext = useContext(Context);
  let history = useHistory();
  history.listen((route) => {
    if (
      decodeURI(getQueryVariable('id')) &&
      decodeURI(getQueryVariable('id')).length > 0 &&
      id !== decodeURI(getQueryVariable('id'))
    ) {
      setID(decodeURI(getQueryVariable('id')));
      setPage(1);
    }
    if (
      decodeURI(getQueryVariable('keywords')) &&
      keyWords !== decodeURI(getQueryVariable('keywords'))
    ) {
      setKeyWords(decodeURI(getQueryVariable('keywords')));
      setPage(1);
    }
  });

  const [newsList, setNewsList] = useState();
  const [page, setPage] = useState(
    window.sessionStorage.getItem('page')
      ? Number(window.sessionStorage.getItem('page'))
      : 1,
  );
  const [pageSize, setPageSize] = useState(20);
  const [total, setTotal] = useState(0);
  const [id, setID] = useState();
  const [keyWords, setKeyWords] = useState('');

  useEffect(() => {
    window.sessionStorage.setItem('page', page);
    document.documentElement.scrollTop = 0;
    if (decodeURI(getQueryVariable('keywords')) != 'false') return;
    if (decodeURI(getQueryVariable('isMenu'))) {
      getNewsListMenu();
    } else {
      getNewsList();
    }
  }, [page, pageSize, id]);

  useEffect(() => {
    if (
      decodeURI(getQueryVariable('keywords')) &&
      decodeURI(getQueryVariable('keywords')).length > 0 &&
      decodeURI(getQueryVariable('keywords')) != 'false'
    ) {
      let params = {
        page: page,
        pageSize: pageSize,
        cid: '',
        title: decodeURI(getQueryVariable('keywords')),
        cate_title: '',
      };
      http.get('/news/achieve_news', params).then((res) => {
        setNewsList(res.data.data);
        setTotal(res.data.total);
      });
    }
  }, [keyWords, page, pageSize]);

  // 获取新闻列表数据
  const getNewsList = () => {
    if (decodeURI(getQueryVariable('id'))) {
      let params = {
        page: page,
        pageSize:
          decodeURI(getQueryVariable('title')).split('/')[1] == 'jqml' ||
          decodeURI(getQueryVariable('title')).split('/')[1] == 'lwj'
            ? 12
            : pageSize,
        cid: decodeURI(getQueryVariable('id')),
        title: '',
        cate_title: '',
      };
      http.get('/news/achieve_news', params).then((res) => {
        setNewsList(res.data.data);
        setTotal(res.data.total);
      });
    }
  };

  const getNewsListMenu = () => {
    if (decodeURI(getQueryVariable('id'))) {
      let params = {
        page: page,
        pageSize:
          decodeURI(getQueryVariable('title')).split('/')[1] == '近期目录' ||
          decodeURI(getQueryVariable('title')).split('/')[1] == '论文集'
            ? 20
            : pageSize,
        cid: decodeURI(getQueryVariable('id')),
      };
      http.get('/news/achieve_list', params).then((res) => {
        setNewsList(res.data.data);
        setTotal(res.data.total);
      });
    }
  };

  // 截取url参数
  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  };

  const toRouter = (path, item, event) => {
    event.preventDefault();
    event.stopPropagation();
    if (item.link_url) return window.open(item.link_url);
    if (decodeURI(getQueryVariable('title')) === 'ssjg') {
      return history.push(
        `/${path}?title=${decodeURI(getQueryVariable('title'))}&id=${
          item.id
        }&cid=${item.cid}`,
      );
      // return window.open(
      //   `/${path}?title=${decodeURI(getQueryVariable('title'))}&id=${
      //     item.id
      //   }&cid=${item.cid}`,
      // );
    }
    history.push(
      `/${path}?title=${decodeURI(getQueryVariable('title')).split('/')[0]}/${
        HomeContext.state.menuTitleList[item.cname]
      }&id=${item.id}&cid=${item.cid}`,
    );
    // window.open(
    //   `/${path}?title=${decodeURI(getQueryVariable('title')).split('/')[0]}/${
    //     item.cname
    //   }&id=${item.id}&cid=${item.cid}`,
    // );
  };
  return (
    <div>
      <div>
        {decodeURI(getQueryVariable('title')).split('/')[1] == 'jqml' ||
        decodeURI(getQueryVariable('title')).split('/')[1] == 'lwj' ? (
          <ul className="coverList">
            {newsList && newsList.length > 0
              ? newsList.map((item, index) => {
                  return (
                    <li
                      key={index}
                      onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <img src={http.baseURL + item.pic_url} alt="" />
                      {HomeContext.state.isMobile ? (
                        <a
                          href={
                            item.link_url
                              ? item.link_url
                              : decodeURI(getQueryVariable('title')) === 'ssjg'
                              ? `http://www.jsic.cn/detail?title=${decodeURI(
                                  getQueryVariable('title'),
                                )}&id=${item.id}&cid=${item.cid}`
                              : `http://www.jsic.cn/detail?title=${
                                  decodeURI(getQueryVariable('title')).split(
                                    '/',
                                  )[0]
                                }/${item.cname}&id=${item.id}&cid=${item.cid}`
                          }
                          dangerouslySetInnerHTML={{ __html: item.title }}
                        >
                          {/* {item.title} */}
                        </a>
                      ) : (
                        <Tooltip placement="bottom" title={item.title}>
                          <a
                            href={
                              item.link_url
                                ? item.link_url
                                : decodeURI(getQueryVariable('title')) ===
                                  'ssjg'
                                ? `http://www.jsic.cn/detail?title=${decodeURI(
                                    getQueryVariable('title'),
                                  )}&id=${item.id}&cid=${item.cid}`
                                : `http://www.jsic.cn/detail?title=${
                                    decodeURI(getQueryVariable('title')).split(
                                      '/',
                                    )[0]
                                  }/${item.cname}&id=${item.id}&cid=${item.cid}`
                            }
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          >
                            {/* {item.title} */}
                          </a>
                        </Tooltip>
                      )}
                    </li>
                  );
                })
              : null}
          </ul>
        ) : (
          <ul className="newList">
            {newsList && newsList.length > 0
              ? newsList.map((item, index) => {
                  return (
                    <li
                      key={index}
                      onClick={toRouter.bind(this, 'detail', item)}
                    >
                      <div></div>
                      <a
                        onClick={toRouter.bind(this, 'detail', item)}
                        href={
                          item.link_url
                            ? item.link_url
                            : decodeURI(getQueryVariable('title')) === 'ssjg'
                            ? `http://www.jsic.cn/detail?title=${decodeURI(
                                getQueryVariable('title'),
                              )}&id=${item.id}&cid=${item.cid}`
                            : `http://www.jsic.cn/detail?title=${
                                decodeURI(getQueryVariable('title')).split(
                                  '/',
                                )[0]
                              }/${item.cname}&id=${item.id}&cid=${item.cid}`
                        }
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      >
                        {/* {item.title} */}
                      </a>
                      {/* <b>[{item.create_time.substring(5, 10)}]</b> */}
                      <b>[{item.create_time}]</b>
                    </li>
                  );
                })
              : null}
          </ul>
        )}

        <Pagination
          defaultCurrent={page}
          defaultPageSize={pageSize}
          current={page}
          pageSize={pageSize}
          total={total}
          itemRender={itemRender}
          showSizeChanger={false}
          responsive={false}
          onChange={(page, pageSize) => {
            setPage(page);
            setPageSize(pageSize);
          }}
        />
      </div>
    </div>
  );
}

export default NewList;
